import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import leftEar from "../../assets/images/Left Ear.svg";
import rightEar from "../../assets/images/Right Ear.svg";
import bothEar from "../../assets/images/Both Ear.svg";



const PhaseTwoUI = ({handleNext, setSelectedEar, selectedEar}) => (
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', height:'20vh'}}>
  <Typography mt={3} mb={5} className='AxiformaBold' align="center" fontWeight={700} fontSize={'32px'} color={"#5E5E5E"}>
  Select the ear(s) you would like to test
  </Typography>

  <Box sx={{ textAlign: "center", mt: '50px', mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: "20px", sm: "40px" },

            mt: "5px",
          }}
        >
        
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button  onClick={() => setSelectedEar("left")} sx={{border: selectedEar === 'left' ? "1.5px solid #D34646 " : "1.5px solid #CFCFCF",  background: selectedEar === "left" ? '#FEF7F6 ' : "",borderRadius:'6px', alignContent:'center', justifyContent:'center', width:'117px', height:'132px',}}>
            <img
              src={leftEar}
              alt="Left Ear"
           
            />
            </Button>
            <Typography
            //   variant={selectedEar === "left" ? "contained" : "outlined"}
             
              sx={{
                color: '#424242',
                fontSize:'21px',
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Left 
            </Typography>
          </Box>

    <Box>
          <Button
           onClick={() => setSelectedEar("both")}
           sx={{border: selectedEar === 'both' ? "1.5px solid #D34646 " : "1.5px solid #CFCFCF",  background: selectedEar === "both" ? '#FEF7F6 ' : "",borderRadius:'6px', alignContent:'center', justifyContent:'center', width:'210px', height:'132px',}}
          >
            <img
              src={bothEar}
              alt="Both Ears"
              
            />
            </Button>
            <Typography
            //   variant={selectedEar === "both" ? "contained" : "outlined"}
             
              sx={{
                color:"#424242",
                fontSize:'21px',
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Both
            </Typography>
          </Box>

      
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button  onClick={() => setSelectedEar("right")} sx={{border: selectedEar === 'right' ? "1.5px solid #D34646 " : "1.5px solid #CFCFCF",  background: selectedEar === "right" ? '#FEF7F6 ' : "",borderRadius:'6px', alignContent:'center', justifyContent:'center', width:'117px', height:'132px',}}>
            
            <img
              src={rightEar}
              alt="Right Ear"
              
            />
            </Button>
            <Typography
            //  variant={selectedEar === "right" ? "contained" : "outlined"}
              sx={{
                color: "#424242",
                fontSize:'21px',
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Right
            </Typography>
          </Box>
        </Box>
      </Box>
    
    <Button  sx={{width:'30vw', height:'12vh',background:'#424242', radius:'8px', alignItems:'center', color:'white', marginTop:'60px'}} onClick={handleNext}>
      <Typography sx={{fontSize:'24px'}}>Confirm Selection</Typography>  
    </Button>

  </Box>
);

export default PhaseTwoUI;
